import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/api/me";

export const Route = createFileRoute("/app/account/")({
  component: ProfileTab,
});

function ProfileTab() {
  const { data, isLoading } = useQuery({ queryKey: ["me"], queryFn: meApi.get });

  return (
    <div className="card max-w-2xl">
      <h2 className="text-lg font-medium">Profile</h2>
      {isLoading ? (
        <p className="mt-4 text-sm text-ink/55">Loading…</p>
      ) : data ? (
        <dl className="mt-4 space-y-3 text-sm">
          <Row label="Email" value={data.user.email} />
          <Row label="User ID" value={<code className="font-mono text-xs">{data.user.id}</code>} />
          <Row label="Member since" value={new Date(data.user.created_at).toLocaleDateString()} />
          {data.user.role === "admin" && <Row label="Role" value={<span className="rounded bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">admin</span>} />}
        </dl>
      ) : null}
    </div>
  );
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between border-b border-ink/8 pb-2 last:border-b-0">
      <dt className="text-ink/55">{label}</dt>
      <dd className="text-ink">{value}</dd>
    </div>
  );
}
